/** Max content width for referral landing sections on large desktops (Figma). */
export const REFERRAL_CONTENT_MAX_WIDTH_PX = 1400;
